import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from 'react-router-dom';
import { requestPasswordResetSchema } from '@pandacalcio/validation';
import { z } from 'zod';
import { api } from '../../lib/api';
import { useAnnouncer } from '../../components/LiveAnnouncer';
import { usePageTitle } from '../../lib/usePageTitle';
import { AuthLayout } from '../../components/AuthLayout';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';

type Input = z.infer<typeof requestPasswordResetSchema>;

export function ForgotPasswordPage() {
  usePageTitle('Password dimenticata');
  const { announce } = useAnnouncer();
  const [sent, setSent] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<Input>({ resolver: zodResolver(requestPasswordResetSchema) });

  const onSubmit = handleSubmit(async (input) => {
    await api('/auth/request-password-reset', { method: 'POST', body: input });
    setSent(true);
    announce('Richiesta inviata. Se l’email esiste, riceverai un link per reimpostare la password.');
  });

  if (sent) {
    return (
      <AuthLayout title="Controlla la tua email">
        <p role="status" className="text-lg">
          Se esiste un account con questa email, riceverai a breve un link per reimpostare la
          password. Il link scade tra un’ora.
        </p>
        <p className="mt-6">
          <Link to="/accedi" className="text-panda-700 underline dark:text-panda-300">
            Torna all’accesso
          </Link>
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Password dimenticata">
      <p className="mb-4 text-ink-700 dark:text-ink-200">
        Inserisci la tua email: ti invieremo un link per scegliere una nuova password.
      </p>
      <form onSubmit={onSubmit} noValidate className="flex flex-col gap-4">
        <TextField
          label="Email"
          type="email"
          autoComplete="email"
          required
          error={errors.email?.message}
          {...register('email')}
        />
        <Button type="submit" loading={isSubmitting} loadingText="Invio in corso…">
          Invia link di reset
        </Button>
      </form>
      <p className="mt-6 text-sm">
        <Link to="/accedi" className="text-panda-700 underline dark:text-panda-300">
          Torna all’accesso
        </Link>
      </p>
    </AuthLayout>
  );
}
